import PropTypes from "prop-types"

import "./hello_interstitial.scss"

const HelloInterstitial = ({
  clickAccept,
  clickAcceptTracking,
  clickAcceptUrl,
  clickDeclineTracking,
  ctaTitle,
  declineCopy,
  logoHtml,
  mainBody,
  mainTitle,
  onClickDecline,
}) => {
  const clickAcceptHandler = event => {
    if (clickAccept) {
      event.preventDefault()
      clickAccept()
    }
  }

  return (
    <div styleName="base">
      <div styleName="popup-container" onClick={onClickDecline}>
        <div styleName="popup-card" onClick={e => e.stopPropagation()}>
          <a
            data-track-ifttt-next-event="click"
            data-track-data={JSON.stringify(clickAcceptTracking)}
            href={clickAcceptUrl}
            onClick={clickAcceptHandler}
          >
            <div styleName="sla-img-container">
              <div
                styleName="logo"
                dangerouslySetInnerHTML={{ __html: logoHtml }}
              />
            </div>
          </a>
          <div styleName="right">
            <a
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify(clickAcceptTracking)}
              href={clickAcceptUrl}
              onClick={clickAcceptHandler}
            >
              <div styleName="copy">
                <h1>{mainTitle}</h1>
                <p>{mainBody}</p>
              </div>
            </a>
            <div className="action-buttons-container">
              <a
                role="button"
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify(clickAcceptTracking)}
                href={clickAcceptUrl}
                onClick={clickAcceptHandler}
                className="button-tertiary"
              >
                {ctaTitle}
              </a>
              <button
                onClick={onClickDecline}
                className="button-tertiary button-cancel-link"
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify(clickDeclineTracking)}
              >
                {declineCopy}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

HelloInterstitial.propTypes = {
  clickAccept: PropTypes.func,
  clickAcceptTracking: PropTypes.object.isRequired,
  clickAcceptUrl: PropTypes.string,
  clickDeclineTracking: PropTypes.object.isRequired,
  ctaTitle: PropTypes.string.isRequired,
  declineCopy: PropTypes.string.isRequired,
  logoHtml: PropTypes.string.isRequired,
  mainBody: PropTypes.string.isRequired,
  mainTitle: PropTypes.string.isRequired,
  onClickDecline: PropTypes.func.isRequired,
}

export default HelloInterstitial
